import React from 'react';
import { useSelector } from 'react-redux';

export const ListerTitle = () => {
	const { pageTitle } = useSelector((state) => state);

	if (!pageTitle) {
		return null;
	}

	return (
		<h1
			className="text-title md:text-display pb-4 pt-4 px-2 md:px-0"
			data-testid="lister-main-title">
			{pageTitle}
		</h1>
	);
};

export default ListerTitle;
